import RenderOnlyInBrowser from "../RenderOnlyInBrowser";
import CheckboxList from "./CheckboxList.client";

export default function ({ taxons = [], onValuesChange }) {
  if (import.meta.env.SSR) return null;

  const params = new URLSearchParams(document.location.search);
  const key = `filter[taxons]`;
  const checked = params.get(key)?.split(",") || [];
  const values = taxons.map(({ name, presentation, id }) => ({
    label: name,
    value: id,
  }));

  return (
    <RenderOnlyInBrowser>
      <CheckboxList
        values={values}
        onValuesChange={onValuesChange}
        checked={checked}
      />
    </RenderOnlyInBrowser>
  );
}
